module.exports = __webpack_public_path__ + "static/media/cloud-computing.1c5c94f0.svg";